import gql from 'graphql-tag';

export const GET_ALL_ATTRACTIONS = gql`
  query attractions(
    $limit: Int = 10000
    $offset: Int = 0
    $search_text: String = "%%"
    $council_profile_id: uuid
  ) {
    attractions(
      where: {
        name: { _ilike: $search_text }
        council_profile_id: { _eq: $council_profile_id }
      }
      limit: $limit
      offset: $offset
    ) {
      id
      name
      description
      type_of_attraction
      image_path
      location
      location_text
      image_url
      created_at
      updated_at
      open_hours
    }
  }
`;
